import {reducerWithInitialState} from "typescript-fsa-reducers";
import { tableInitialState, deepCopyTableThingyState } from "../typing/tablestates";
import {NetworkTableThingyActions} from "../actions/table_actions";

export default reducerWithInitialState(tableInitialState)
        .case(NetworkTableThingyActions.resetData, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            if (payload.data){
                deepCopy.model=payload.data;

               deepCopy.view.loaded = true;
            }
            return deepCopy;
        })
        .case(NetworkTableThingyActions.setDeleteItem, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            if (payload){
               deepCopy.itemToDelete = payload.setDeleteItem;
            }
            return deepCopy;
        })
        .case(NetworkTableThingyActions.setRuleScanmasterItem, (state,payload) => {
            const deepCopy=deepCopyTableThingyState(state);
            if (payload){
             //  deepCopy.scanmasterlist = payload.setScanMasterItem;
            }
            return deepCopy;
        })
        ;